<div class="fonb-shell">

  <!-- Header -->
  <div class="fonb-header">
    <div>
      <button type="button" class="fonb-backlink" (click)="backToList()">
        <i class="pi pi-arrow-left"></i>
        {{ 'FLEXI_ONBOARDING.LIST.BACK_TO_LIST' | translate }}
      </button>
      <h2 class="fonb-header__title">{{ 'FLEXI_ONBOARDING.TITLE' | translate }}</h2>
      <p class="fonb-header__meta">
        <i class="pi pi-building"></i> {{ 'FLEXI_ONBOARDING.BUSINESS_HASH' | translate }}{{ aggregate.businessId }}
        <ng-container *ngIf="aggregate.validUntil">
          <span class="fonb-dot">·</span>
          <span>{{ 'FLEXI_ONBOARDING.VALID_UNTIL' | translate }} {{ aggregate.validUntil }}</span>
        </ng-container>
      </p>
    </div>

    <div class="fonb-header__status" [ngClass]="{
      'is-not-started': aggregate.status === Status.NotStarted,
      'is-in-progress': aggregate.status === Status.InProgress,
      'is-completed': aggregate.status === Status.Completed
    }">
      <i class="pi" [ngClass]="{
        'pi-clock': aggregate.status === Status.NotStarted,
        'pi-spinner': aggregate.status === Status.InProgress,
        'pi-check-circle': aggregate.status === Status.Completed
      }"></i>
      <span *ngIf="aggregate.status === Status.NotStarted">{{ 'FLEXI_ONBOARDING.STATUS.NOT_STARTED' | translate }}</span>
      <span *ngIf="aggregate.status === Status.InProgress">{{ 'FLEXI_ONBOARDING.STATUS.IN_PROGRESS' | translate }}</span>
      <span *ngIf="aggregate.status === Status.Completed">{{ 'FLEXI_ONBOARDING.STATUS.COMPLETED' | translate }}</span>
    </div>
  </div>

  <!-- Completion banner -->
  <div class="fonb-banner fonb-banner--success" *ngIf="isCompleted">
    <i class="pi pi-check-circle"></i>
    <div>
      <strong>{{ completedBannerTitleKey | translate }}</strong>
      {{ 'FLEXI_ONBOARDING.COMPLETED_BANNER_BODY' | translate }}
    </div>
    <button type="button" class="fonb-banner__action" (click)="reopen()" [disabled]="saving">
      <i class="pi pi-pencil"></i> {{ 'FLEXI_ONBOARDING.ACTIONS.REOPEN' | translate }}
    </button>
  </div>

  <!-- Restore-defaults panel — surfaces catalog steps the CSM removed -->
  <div class="fonb-restore" *ngIf="removedDefaults.length && !isCompleted">
    <div class="fonb-restore__head">
      <i class="pi pi-history"></i>
      <strong>{{ 'FLEXI_ONBOARDING.RESTORE.HEAD' | translate }}</strong>
      <span class="fonb-muted">{{ 'FLEXI_ONBOARDING.RESTORE.HINT' | translate }}</span>
    </div>
    <div class="fonb-restore__chips">
      <button type="button" class="fonb-restore__chip"
              *ngFor="let s of removedDefaults"
              (click)="restoreDefaultStep(s)"
              [disabled]="saving"
              [title]="s.title">
        <i class="pi pi-undo"></i>
        <span>{{ s.shortLabel || s.title }}</span>
      </button>
    </div>
  </div>

  <!-- Error banner -->
  <div class="fonb-banner fonb-banner--error" *ngIf="errorMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <div>{{ errorMessage }}</div>
    <button type="button" class="fonb-banner__action" (click)="errorMessage = null">{{ 'FLEXI_ONBOARDING.DISMISS' | translate }}</button>
  </div>

  <!-- Stepper -->
  <div class="fonb-stepper">
    <div class="fonb-stepnav" role="tablist">

      <button type="button"
              class="fonb-stepnav__gap is-edge"
              (click)="openAddStep(0)"
              [disabled]="addStepOpen || isCompleted"
              [attr.aria-label]="'FLEXI_ONBOARDING.STEPNAV.INSERT_AT_START' | translate"
              [title]="'FLEXI_ONBOARDING.STEPNAV.INSERT_HERE' | translate">
        <span class="fonb-stepnav__plus"><i class="pi pi-plus"></i></span>
      </button>

      <ng-container *ngFor="let step of aggregate.steps; let i = index">
        <div class="fonb-stepnav__item"
             [class.is-active]="i === activeIndex"
             [class.is-completed]="step.status === Status.Completed">
          <button type="button"
                  class="fonb-stepnav__circle"
                  (click)="jumpTo(i)"
                  [attr.aria-current]="i === activeIndex ? 'step' : null"
                  [title]="(i + 1) + '. ' + step.title">
            <i class="pi pi-check" *ngIf="step.status === Status.Completed; else stepNum"></i>
            <ng-template #stepNum>{{ i + 1 }}</ng-template>
            <span class="fonb-stepnav__remove"
                  *ngIf="aggregate.steps.length > 1 && !isCompleted"
                  (click)="removeStepAt($event, i)"
                  [attr.aria-label]="'FLEXI_ONBOARDING.STEPNAV.REMOVE_STEP' | translate"
                  [title]="'FLEXI_ONBOARDING.STEPNAV.REMOVE_STEP' | translate">
              <i class="pi pi-times"></i>
            </span>
          </button>
          <span class="fonb-stepnav__label" [class.is-custom]="!step.isDefault">
            {{ step.shortLabel }}
            <small *ngIf="!step.isDefault" class="fonb-stepnav__customtag">{{ 'FLEXI_ONBOARDING.CUSTOM_TAG' | translate }}</small>
          </span>
        </div>

        <button type="button"
                class="fonb-stepnav__gap"
                *ngIf="i < aggregate.steps.length - 1"
                (click)="openAddStep(i + 1)"
                [disabled]="addStepOpen || isCompleted"
                [attr.aria-label]="'FLEXI_ONBOARDING.STEPNAV.INSERT_HERE' | translate"
                [title]="'FLEXI_ONBOARDING.STEPNAV.INSERT_HERE' | translate">
          <span class="fonb-stepnav__plus"><i class="pi pi-plus"></i></span>
        </button>
      </ng-container>

      <button type="button"
              class="fonb-stepnav__addtile"
              (click)="openAddStep(aggregate.steps.length)"
              [disabled]="addStepOpen || isCompleted"
              [title]="'FLEXI_ONBOARDING.STEPNAV.ADD_AT_END' | translate">
        <i class="pi pi-plus"></i>
        <span>{{ 'FLEXI_ONBOARDING.STEPNAV.ADD_STEP' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Add-step inline panel -->
  <div class="fonb-addpanel" *ngIf="addStepOpen">
    <div class="fonb-addpanel__head">
      <i class="pi pi-plus-circle"></i>
      <strong>{{ 'FLEXI_ONBOARDING.ADD_PANEL.HEAD' | translate }}</strong>
      <span class="fonb-muted">— {{ addStepLabel }}</span>
      <button type="button" class="fonb-addpanel__close" (click)="cancelAddStep()" [attr.aria-label]="'CLOSE' | translate">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="fonb-addpanel__body">
      <div class="fonb-addpanel__row">
        <label>
          <span>{{ 'FLEXI_ONBOARDING.ADD_PANEL.TITLE_LABEL' | translate }} <small class="fonb-required">*</small></span>
          <input type="text" class="fonb-input" [(ngModel)]="addStepInput.title"
                 [placeholder]="'FLEXI_ONBOARDING.ADD_PANEL.TITLE_PLACEHOLDER' | translate" />
        </label>
        <label>
          <span>{{ 'FLEXI_ONBOARDING.ADD_PANEL.SHORT_LABEL' | translate }} <small>{{ 'FLEXI_ONBOARDING.ADD_PANEL.SHORT_DESC' | translate }}</small></span>
          <input type="text" class="fonb-input" [(ngModel)]="addStepInput.shortLabel"
                 [placeholder]="'FLEXI_ONBOARDING.ADD_PANEL.SHORT_PLACEHOLDER' | translate" maxlength="32" />
        </label>
      </div>
      <label>
        <span>{{ 'FLEXI_ONBOARDING.ADD_PANEL.SUBTITLE_LABEL' | translate }} <small>{{ 'FLEXI_ONBOARDING.ADD_PANEL.SUBTITLE_DESC' | translate }}</small></span>
        <input type="text" class="fonb-input" [(ngModel)]="addStepInput.subtitle"
               [placeholder]="'FLEXI_ONBOARDING.ADD_PANEL.OPTIONAL' | translate" />
      </label>
      <label>
        <span>{{ 'FLEXI_ONBOARDING.ADD_PANEL.TEMPLATE_LABEL' | translate }} <small>{{ 'FLEXI_ONBOARDING.ADD_PANEL.TEMPLATE_DESC' | translate }}</small></span>
        <textarea class="fonb-textarea" rows="4" [(ngModel)]="addStepInput.templateText"
                  [placeholder]="'FLEXI_ONBOARDING.ADD_PANEL.OPTIONAL' | translate"></textarea>
      </label>
    </div>
    <div class="fonb-addpanel__foot">
      <button type="button" class="fonb-btn fonb-btn--ghost" (click)="cancelAddStep()">{{ 'CANCEL' | translate }}</button>
      <button type="button" class="fonb-btn fonb-btn--primary" (click)="submitAddStep()" [disabled]="!addStepInput.title.trim() || saving">
        <i class="pi pi-check"></i> {{ 'FLEXI_ONBOARDING.ADD_PANEL.CREATE' | translate }}
      </button>
    </div>
  </div>

  <!-- Step body -->
  <div class="fonb-body" *ngIf="currentStep">
    <div class="fonb-step-head">
      <div>
        <h3 class="fonb-step-head__title">
          {{ currentStep.title }}
          <span class="fonb-typetag" [class.is-default]="currentStep.isDefault" [class.is-custom]="!currentStep.isDefault">
            {{ (currentStep.isDefault ? 'FLEXI_ONBOARDING.DEFAULT_TAG' : 'FLEXI_ONBOARDING.CUSTOM_TAG') | translate }}
          </span>
        </h3>
        <p class="fonb-step-head__sub">{{ currentStep.subtitle || (!currentStep.isDefault ? ('FLEXI_ONBOARDING.CUSTOM_STEP_DESC' | translate) : '') }}</p>
      </div>
      <span class="fonb-pill">{{ 'FLEXI_ONBOARDING.STEP_OF' | translate:{ current: (activeIndex + 1), total: aggregate.steps.length } }}</span>
    </div>

    <div class="fonb-grid">
      <section class="fonb-grid__main">

        <div class="fonb-block" *ngIf="currentStep.templateText">
          <label class="fonb-label">
            <i class="pi pi-book"></i> {{ 'FLEXI_ONBOARDING.TEMPLATE_TEXT' | translate }}
            <small>{{ (currentStep.isDefault ? 'FLEXI_ONBOARDING.TEMPLATE_BASELINE' : 'FLEXI_ONBOARDING.TEMPLATE_CUSTOM_BASELINE') | translate }}</small>
          </label>
          <div class="fonb-template" [innerHTML]="renderTemplate(currentStep.templateText)"></div>
        </div>

        <div class="fonb-block">
          <div class="fonb-editor-head">
            <label class="fonb-label fonb-label--row">
              <i class="pi pi-pencil"></i> {{ 'FLEXI_ONBOARDING.AUTHORED_TEXT' | translate }}
              <small>{{ 'FLEXI_ONBOARDING.AUTHORED_TEXT_HINT' | translate }}</small>
            </label>
            <div class="fonb-editor-head__actions">
              <button type="button"
                      class="fonb-btn fonb-btn--ghost fonb-btn--sm"
                      (click)="insertTemplate()"
                      [disabled]="!currentStep.templateText || isCompleted">
                <i class="pi pi-copy"></i>
                {{ (hasAuthoredContent() ? 'FLEXI_ONBOARDING.REPLACE_WITH_TEMPLATE' : 'FLEXI_ONBOARDING.USE_TEMPLATE') | translate }}
              </button>
              <button type="button"
                      class="fonb-btn fonb-btn--ghost fonb-btn--sm"
                      *ngIf="hasAuthoredContent()"
                      (click)="clearOverride()"
                      [disabled]="isCompleted">
                <i class="pi pi-undo"></i> {{ 'FLEXI_ONBOARDING.CLEAR' | translate }}
              </button>
            </div>
          </div>
          <ckeditor
            [editor]="Editor"
            [(ngModel)]="editableModel"
            [config]="editorConfig"
            [disabled]="isCompleted"
            class="fonb-editor">
          </ckeditor>
          <small class="fonb-hint">{{ 'FLEXI_ONBOARDING.LEAVE_BLANK_HINT' | translate }}</small>
        </div>

        <div class="fonb-block fonb-pdf-action" *ngIf="currentStep.stepKey === 'OhsAgreement'">
          <button type="button" class="fonb-btn fonb-btn--outline" (click)="downloadOhsAgreementPdf()" [disabled]="!isCompleted">
            <i class="pi pi-download"></i> {{ 'FLEXI_ONBOARDING.DOWNLOAD_CONFIRMATION_PDF' | translate }}
          </button>
          <small class="fonb-hint">{{ 'FLEXI_ONBOARDING.DOWNLOAD_PDF_HINT' | translate }}</small>
        </div>
      </section>

      <aside class="fonb-grid__side">
        <div class="fonb-comments">
          <div class="fonb-comments__head">
            <h5><i class="pi pi-comments"></i> {{ 'FLEXI_ONBOARDING.COMMENTS' | translate }}</h5>
            <span class="fonb-badge">{{ comments.length }}</span>
          </div>
          <p class="fonb-hint">{{ 'FLEXI_ONBOARDING.COMMENTS_INTRO' | translate }}</p>

          <div class="fonb-comments__loading" *ngIf="loadingComments">{{ 'FLEXI_ONBOARDING.LOADING' | translate }}</div>
          <div class="fonb-comments__list" *ngIf="!loadingComments && comments.length">
            <div class="fonb-comment" *ngFor="let c of comments">
              <div class="fonb-comment__meta">
                <span><strong>{{ c.createdByName || ('FLEXI_ONBOARDING.ADVISOR' | translate) }}</strong> · {{ c.createdOn | date:'dd-MM-yyyy HH:mm' }}</span>
                <span class="fonb-comment__meta-right">
                  <span class="fonb-tag fonb-tag--action" *ngIf="c.commentType === CommentType.Action">
                    {{ 'FLEXI_ONBOARDING.COMMENT_TYPE.ACTION' | translate }}
                  </span>
                  <span class="fonb-tag fonb-tag--decision" *ngIf="c.commentType === CommentType.Decision">
                    {{ 'FLEXI_ONBOARDING.COMMENT_TYPE.DECISION' | translate }}
                  </span>
                  <span class="fonb-tag" *ngIf="c.isPublic && c.commentType === CommentType.Note">{{ 'FLEXI_ONBOARDING.PUBLIC_TAG' | translate }}</span>
                  <button type="button" class="fonb-comment__delete"
                          *ngIf="canDeleteComment(c)"
                          (click)="deleteComment(c)"
                          [disabled]="deletingCommentIds.has(c.id)"
                          [attr.aria-label]="'FLEXI_ONBOARDING.DELETE_COMMENT' | translate"
                          [title]="'FLEXI_ONBOARDING.DELETE_COMMENT' | translate">
                    <i class="pi pi-trash"></i>
                  </button>
                </span>
              </div>
              <div class="fonb-comment__body">{{ c.commentText }}</div>
              <!-- Action metadata: who owns it + when it's due -->
              <div class="fonb-comment__action-meta" *ngIf="c.commentType === CommentType.Action">
                <span class="fonb-comment__chip">
                  <i class="pi pi-user"></i>
                  {{ (c.responsibleParty === Responsible.Advisor
                      ? 'FLEXI_ONBOARDING.RESPONSIBLE.ADVISOR'
                      : 'FLEXI_ONBOARDING.RESPONSIBLE.CUSTOMER') | translate }}
                </span>
                <span class="fonb-comment__chip" *ngIf="c.deadline">
                  <i class="pi pi-calendar"></i>
                  {{ 'FLEXI_ONBOARDING.DEADLINE' | translate }}: {{ c.deadline }}
                </span>
              </div>
            </div>
          </div>
          <div class="fonb-comments__empty" *ngIf="!loadingComments && !comments.length">{{ 'FLEXI_ONBOARDING.NO_COMMENTS_YET' | translate }}</div>

          <div class="fonb-comments__form" *ngIf="!isCompleted">
            <textarea class="fonb-textarea" rows="2" [placeholder]="'FLEXI_ONBOARDING.COMMENT_PLACEHOLDER' | translate" [(ngModel)]="newComment"></textarea>

            <!-- Type / Responsible / Deadline row -->
            <div class="fonb-comment-classify">
              <label class="fonb-comment-classify__field">
                <span>{{ 'FLEXI_ONBOARDING.COMMENT_TYPE.LABEL' | translate }}</span>
                <select class="fonb-input fonb-input--sm" [(ngModel)]="newCommentType" (ngModelChange)="onCommentTypeChange()">
                  <option [ngValue]="CommentType.Note">{{ 'FLEXI_ONBOARDING.COMMENT_TYPE.NOTE' | translate }}</option>
                  <option [ngValue]="CommentType.Action">{{ 'FLEXI_ONBOARDING.COMMENT_TYPE.ACTION' | translate }}</option>
                  <option [ngValue]="CommentType.Decision">{{ 'FLEXI_ONBOARDING.COMMENT_TYPE.DECISION' | translate }}</option>
                </select>
              </label>

              <!-- Only meaningful for Actions: responsible party + optional deadline -->
              <ng-container *ngIf="isNewCommentAction">
                <label class="fonb-comment-classify__field">
                  <span>{{ 'FLEXI_ONBOARDING.RESPONSIBLE.LABEL' | translate }}</span>
                  <select class="fonb-input fonb-input--sm" [(ngModel)]="newCommentResponsible">
                    <option [ngValue]="Responsible.Customer">{{ 'FLEXI_ONBOARDING.RESPONSIBLE.CUSTOMER' | translate }}</option>
                    <option [ngValue]="Responsible.Advisor">{{ 'FLEXI_ONBOARDING.RESPONSIBLE.ADVISOR' | translate }}</option>
                  </select>
                </label>
                <label class="fonb-comment-classify__field">
                  <span>{{ 'FLEXI_ONBOARDING.DEADLINE' | translate }}</span>
                  <input type="date" class="fonb-input fonb-input--sm" [(ngModel)]="newCommentDeadline" />
                </label>
              </ng-container>
            </div>

            <div class="fonb-comments__formfoot">
              <label class="fonb-check fonb-check--inline"
                     [title]="newCommentType !== CommentType.Note ? ('FLEXI_ONBOARDING.COMMENT_PUBLIC_FORCED' | translate) : null">
                <input type="checkbox" [(ngModel)]="newCommentIsPublic" [disabled]="newCommentType !== CommentType.Note" />
                <span>{{ 'FLEXI_ONBOARDING.COMMENT_PUBLIC' | translate }}</span>
              </label>
              <button type="button" class="fonb-btn fonb-btn--primary fonb-btn--sm"
                      (click)="addComment()" [disabled]="!newComment.trim() || postingComment">
                <i class="pi" [ngClass]="postingComment ? 'pi-spin pi-spinner' : 'pi-plus'"></i>
                {{ 'FLEXI_ONBOARDING.COMMENT_ADD' | translate }}
              </button>
            </div>
          </div>
        </div>
      </aside>
    </div>

    <div class="fonb-actions">
      <button type="button" class="fonb-btn fonb-btn--ghost" (click)="prev()" [disabled]="activeIndex === 0">
        <i class="pi pi-chevron-left"></i> {{ 'FLEXI_ONBOARDING.ACTIONS.PREVIOUS' | translate }}
      </button>
      <div class="fonb-actions__right">
        <button type="button" class="fonb-btn fonb-btn--outline" (click)="save()" [disabled]="saving || isCompleted">
          <i class="pi pi-save"></i> {{ 'FLEXI_ONBOARDING.ACTIONS.SAVE' | translate }}
        </button>
        <button type="button" class="fonb-btn fonb-btn--primary" *ngIf="!isLastStep" (click)="saveAndNext()" [disabled]="saving || isCompleted">
          {{ 'FLEXI_ONBOARDING.ACTIONS.SAVE_AND_NEXT' | translate }} <i class="pi pi-chevron-right"></i>
        </button>
        <button type="button" class="fonb-btn fonb-btn--success" *ngIf="isLastStep && !isCompleted" (click)="complete()" [disabled]="saving">
          <i class="pi pi-check-circle"></i> {{ completeActionKey | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  [header]="'CONFIRMATION' | translate"
  icon="pi pi-question-circle"
  [style]="{ width: '460px' }"
  [acceptLabel]="'SWITCH_YES' | translate"
  [rejectLabel]="'SWITCH_NO' | translate">
</p-confirmDialog>
